import { render, staticRenderFns } from "./roles-filter.vue?vue&type=template&id=8cc44b06&"
import script from "./roles-filter.vue?vue&type=script&lang=js&"
export * from "./roles-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports